import React, { useCallback, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

import { useApp } from '../../context/AppContext';
import { useProduct } from '../../context/ProductContext';

import { sendGTMEvent } from '../../utils/analytics';
import { GA4_KEY, PRODUCT_CATEGORIES, ROUTES } from '../../utils/constants';

import ProductItem from '../ProductItem/ProductItem';

import styles from './ProductList.module.css';
import { colors } from '../../styles/colors';

const ProductList = () => {
  const navigate = useNavigate();
  const { telegram, appContent } = useApp();

  const { posts, guides, products } = appContent;

  const { activeCategory, selectedProduct, setSelectedProduct, setProductId } =
    useProduct();

  const handleBackButton = useCallback(() => {
    setSelectedProduct(null);
    telegram.HapticFeedback.impactOccurred('medium');
    telegram.setHeaderColor(colors.background.backend);
    telegram.BackButton.hide();
    //eslint-disable-next-line
  }, [setSelectedProduct]);

  useEffect(() => {
    if (selectedProduct) {
      telegram.BackButton.show();
      telegram.setHeaderColor(colors.background.main);
      telegram.BackButton.onClick(handleBackButton);
    } else {
      telegram.BackButton.hide();
    }

    return () => {
      if (telegram.BackButton.onClick) {
        telegram.BackButton.onClick(null);
      }
    };
    //eslint-disable-next-line
  }, [selectedProduct, handleBackButton]);

  const openProductModal = useCallback(
    (product) => {
      setSelectedProduct(product);
      setProductId(product.id);

      telegram.HapticFeedback.impactOccurred('medium');
      navigate(ROUTES.product(product.id));
      setTimeout(() => {
        sendGTMEvent(GA4_KEY.open_product(product.title, activeCategory));
      }, 0);
    },
    //eslint-disable-next-line
    [activeCategory, navigate, setSelectedProduct, setProductId]
  );

  const activeProducts = React.useMemo(
    () => {
      switch (activeCategory) {
        case PRODUCT_CATEGORIES.guides.key:
          return guides;
        case PRODUCT_CATEGORIES.highlights.key:
          return posts;
        case PRODUCT_CATEGORIES.products.key:
          return products;
        default:
          return [];
      }
    },
    [activeCategory, guides, posts, products]
  );

  return (
    <div className={styles.productListContainer}>
      <div className={styles.productList} key={activeCategory}>
        {activeProducts?.map((product) => (
          <ProductItem
            key={product?.id}
            product={product}
            onClick={() => openProductModal(product)}
          />
        ))}
      </div>
    </div>
  );
};

export default React.memo(ProductList);
